import { useNavigate } from 'react-router-dom';

import type { ViewedOrganization } from '@/api/viewing-scope';
import { ROUTES } from '@/app/routes';
import { useViewingAs } from '@/auth/useViewingAs';

/**
 * Start viewing an organization's portal read-only, and go to its dashboard.
 *
 * One function for both places staff start from - the account page and a row
 * of the list - so the two cannot drift into doing it differently.
 */
export function useViewPortal() {
  const { enter } = useViewingAs();
  const navigate = useNavigate();

  return (organization: ViewedOrganization) => {
    enter(organization);
    void navigate(ROUTES.dashboard);
  };
}
